import { useDataLayerAction } from '../TagContext'
import { useEffect, useRef } from 'react'
import { CategoryInterface, Maybe, Products } from '@pylot-data/fwrdschema'

export const usePlpTracking = (
    category?: Maybe<CategoryInterface>,
    isValidating?: boolean,
    visibleProductData?: Maybe<Products>
): void => {
    const dataLayerAction = useDataLayerAction()
    const lastTrackedStepRef = useRef<CategoryInterface>()

    useEffect(() => {
        if (
            category &&
            !isValidating &&
            category.name !== lastTrackedStepRef.current?.name
        ) {
            dataLayerAction({
                type: 'PLP',
                data: {
                    category,
                    products: visibleProductData
                }
            })
            lastTrackedStepRef.current = category
        }
    }, [dataLayerAction, category])
}
